import { FacetData } from "@/lib/factfinder/factfinder-interfaces"

const DISCRETE_DUPLICATE_SUFFIX = "_txt"
const NUMERIC_FACET_TYPES = new Set(["FLOAT", "INTEGER", "DOUBLE"])

function getFieldNameWithoutUnit(fieldName: string | undefined): string {
  return (fieldName ?? "").split("~~")[0].toLowerCase()
}

function getDuplicateBaseName(fieldName: string | undefined): string {
  const fieldNameWithoutUnit = getFieldNameWithoutUnit(fieldName)

  return fieldNameWithoutUnit.endsWith(DISCRETE_DUPLICATE_SUFFIX)
    ? fieldNameWithoutUnit.slice(0, -DISCRETE_DUPLICATE_SUFFIX.length)
    : fieldNameWithoutUnit
}

function isNumericFacet(facet: FacetData): boolean {
  return NUMERIC_FACET_TYPES.has((facet.facetType ?? "").toUpperCase())
}

function isDiscreteDuplicateCandidate(facet: FacetData): boolean {
  return getFieldNameWithoutUnit(facet.fieldName).endsWith(DISCRETE_DUPLICATE_SUFFIX)
}

function hasSelectedElements(facet: FacetData): boolean {
  return facet.selectedFacetElements.length > 0
}

export function filterDuplicateDiscreteFacets(facets: FacetData[]): FacetData[] {
  const numericFacetBaseNames = new Set(
    facets.filter(isNumericFacet).map((facet) => getDuplicateBaseName(facet.fieldName)).filter(Boolean)
  )

  return facets.filter((facet) => {
    if (!isDiscreteDuplicateCandidate(facet)) {
      return true
    }

    if (hasSelectedElements(facet)) {
      return true
    }

    return !numericFacetBaseNames.has(getDuplicateBaseName(facet.fieldName))
  })
}
